// Who hosts which holiday, by year.
//
// This is a negotiated family schedule, not a formula. Christmas Eve happens to
// cycle through the seven families cleanly, but Thanksgiving doesn't - 2028
// onward re-shuffles - so don't be tempted to "simplify" this into a rotation.
// When the family sorts out 2031, add the years here and everything else
// (next-up card, countdown, calendar links) picks them up on its own.

export const THANKSGIVING = 'thanksgiving'
export const CHRISTMAS_EVE = 'christmasEve'

export const HOLIDAYS = [
  { key: THANKSGIVING, name: 'Thanksgiving', emoji: '🦃' },
  { key: CHRISTMAS_EVE, name: 'Christmas Eve', emoji: '🎄' }
]

export const hostsByYear = {
  [THANKSGIVING]: {
    2021: 'Grosso Seltzers',
    2022: 'Grand',
    2023: 'Patricks',
    2024: 'Slaters',
    2025: 'Grosso Gasteyers',
    2026: 'Grossos',
    2027: 'Grosso Sippels',
    2028: 'Patricks',
    2029: 'Grosso Seltzers',
    2030: 'Grand'
  },
  [CHRISTMAS_EVE]: {
    2021: 'Grand',
    2022: 'Grosso Seltzers',
    2023: 'Grosso Sippels',
    2024: 'Patricks',
    2025: 'Slaters',
    2026: 'Grosso Gasteyers',
    2027: 'Grossos',
    2028: 'Grand',
    2029: 'Grosso Seltzers',
    2030: 'Grosso Sippels'
  }
}

export const hostFor = (holidayKey, year) => (hostsByYear[holidayKey] || {})[year] || null
